/**
 * Course page: click a hole card to open it in a fullscreen modal.
 *
 * The modal clones the card's inline SVG (already in the page — no fetching)
 * and adds prev/next navigation so all 18 holes can be flipped through with
 * the arrow keys or on-screen buttons. Esc / backdrop click / ✕ closes.
 */

function setupHoleModal() {
  const cards = Array.from(document.querySelectorAll(".hole-card"));
  if (!cards.length) return;

  const dialog = document.createElement("dialog");
  dialog.className = "hole-modal";
  dialog.innerHTML = `
    <div class="hole-modal__bar">
      <span class="hole-modal__title"></span>
      <span class="hole-modal__par"></span>
      <button class="hole-modal__close" type="button" aria-label="Close">✕</button>
    </div>
    <div class="hole-modal__map" aria-live="polite"></div>
    <button class="hole-modal__nav hole-modal__nav--prev" type="button" aria-label="Previous hole">&larr;</button>
    <button class="hole-modal__nav hole-modal__nav--next" type="button" aria-label="Next hole">&rarr;</button>
  `;
  document.body.appendChild(dialog);

  const map = dialog.querySelector(".hole-modal__map");
  const title = dialog.querySelector(".hole-modal__title");
  const par = dialog.querySelector(".hole-modal__par");

  let idx = 0;

  function show(i) {
    idx = (i + cards.length) % cards.length;
    const card = cards[idx];
    const num = card.querySelector(".hole-card__num")?.textContent ?? "";
    const parText = card.querySelector(".hole-card__par")?.textContent ?? "";
    const svg = card.querySelector("svg");
    map.innerHTML = svg ? svg.outerHTML : "";
    title.textContent = `HOLE ${num}`;
    par.textContent = parText;
  }

  cards.forEach((card, i) => {
    card.setAttribute("role", "button");
    card.setAttribute("tabindex", "0");
    const num = card.querySelector(".hole-card__num")?.textContent ?? i + 1;
    card.setAttribute("aria-label", `View hole ${num} full screen`);

    const open = () => {
      show(i);
      dialog.showModal();
    };
    card.addEventListener("click", open);
    card.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        open();
      }
    });
  });

  dialog.querySelector(".hole-modal__close").addEventListener("click", () => dialog.close());
  dialog.querySelector(".hole-modal__nav--prev").addEventListener("click", () => show(idx - 1));
  dialog.querySelector(".hole-modal__nav--next").addEventListener("click", () => show(idx + 1));

  // Arrow keys flip holes while the modal is open.
  dialog.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") show(idx - 1);
    else if (e.key === "ArrowRight") show(idx + 1);
  });

  // Clicking the dark area outside the content closes the modal.
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) dialog.close();
  });
}

document.addEventListener("DOMContentLoaded", setupHoleModal);
